import { FREIGHT_TYPE, WASTE_FREIGHT_TYPE_SCHEMA } from '@schuettflix/interfaces';

export function isWasteFreightType(freightType?: FREIGHT_TYPE) {
    return WASTE_FREIGHT_TYPE_SCHEMA.safeParse(freightType).success;
}
